import React, { useEffect } from 'react';
import { Cookie } from 'lucide-react';

const CookiePolicy: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <section className="bg-gradient-to-br from-primary-dark via-primary to-accent py-16">
        <div className="container mx-auto px-4 text-center text-white">
          <Cookie className="w-16 h-16 mx-auto mb-4" />
          <h1 className="text-5xl font-extrabold mb-4 drop-shadow-2xl">Política de Cookies</h1>
          <p className="text-xl font-light drop-shadow-lg">Última actualización: 19 de octubre de 2025</p>
        </div>
      </section>

      <section className="py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-lg">
            <div className="prose prose-lg max-w-none
              [&>h2]:text-2xl [&>h2]:font-bold [&>h2]:text-primary [&>h2]:mt-8 [&>h2]:mb-4 [&>h2]:pb-2 [&>h2]:border-b-2 [&>h2]:border-accent/30
              [&>p]:text-gray-700 [&>p]:leading-relaxed [&>p]:mb-4
              [&>ul]:list-disc [&>ul]:list-inside [&>ul]:space-y-2 [&>ul]:mb-4 [&>ul]:text-gray-700
              [&>ul>li]:ml-4">
              <p>Esta Política explica qué son las cookies y tecnologías similares, cómo las utiliza trabajofuera.com y cómo puede gestionarlas.</p>

              <h2>1. ¿Qué son las cookies?</h2>
              <p>Las cookies son pequeños archivos que el sitio web instala en su dispositivo para permitir o mejorar su funcionamiento. Tecnologías similares incluyen local storage, web beacons o píxeles.</p>

              <h2>2. ¿Qué cookies utilizamos?</h2>
              <p>En este momento solo usamos cookies o tecnologías estrictamente necesarias para: (i) habilitar funciones básicas del sitio, (ii) mantener la seguridad y (iii) distribuir contenido a través de nuestra red de alojamiento.</p>
              <ul>
                <li>Cookies estrictamente necesarias: imprescindibles para que el sitio funcione (p. ej., equilibrio de carga, enrutamiento, seguridad).</li>
              </ul>
              <p>No utilizamos cookies de analítica, publicidad ni personalización en este momento. Si en el futuro incorporamos cookies no esenciales, solicitaremos su consentimiento previo y actualizaremos esta Política.</p>

              <h2>3. Proveedores</h2>
              <p>Alojamos y distribuimos el sitio mediante Netlify (servicios de hosting/CDN). Estos servicios pueden utilizar cookies o mecanismos equivalentes estrictamente necesarios para prestar el servicio (por ejemplo, para el enrutamiento y la seguridad).</p>

              <h2>4. Gestión de cookies</h2>
              <p>Puesto que actualmente solo empleamos cookies estrictamente necesarias, no es preciso un panel de consentimiento. Puede, no obstante, configurar su navegador para bloquear o eliminar cookies. Tenga en cuenta que bloquear cookies necesarias puede afectar al funcionamiento del sitio.</p>

              <h2>5. Transferencias y protección</h2>
              <p>Si, por razón de la infraestructura del proveedor o su red de distribución, se produjeran transferencias internacionales de datos (p. ej., direcciones IP en registros de acceso), aplicaremos las garantías adecuadas (como las cláusulas contractuales tipo) conforme a la normativa aplicable.</p>

              <h2>6. Cambios en esta Política</h2>
              <p>Podemos actualizar esta Política para reflejar cambios en el uso de cookies o en la normativa. La versión vigente se publicará en esta página indicando la fecha de última actualización.</p>

              <h2>7. Contacto</h2>
              <p>Para dudas sobre el uso de cookies, puede escribir a info@trabajofuera.com (a la atención de Hamish Jefford).</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicy;
